const url = "/api/v1/recommendations";

export type RecommendationsIndexTypes = "pending" | "determined" | "saved";

export type RecommendationsIndexParams = {
  type: RecommendationsIndexTypes;
};

export interface Tag {
  description: string;
  name: string;
}

export type RecommendationType = "reminder" | "task" | "tip";
export type SaveableRecommendationType = "task" | "tip";
export type AddYourOwnRecommendationType = "task" | "tip";

export type RecommendationSerializer = {
  attributes: {
    id: number;
    completedAt: string | null;
    content: string;
    createdAt: string;
    evidenceTag: Tag | null;
    expiredAt: string | null;
    isMemberCreated: boolean;
    linkText: string;
    linkUrl: string;
    markedAlreadyDoneAt: string | null;
    markedDontShowAgainAt: string | null;
    primaryTag: Tag | null;
    savedForLaterAt: string | null;
    type: RecommendationType;
  };
};

export type Recommendation = RecommendationSerializer["attributes"];

export interface RecommendationsIndexResponse {
  data: RecommendationSerializer[];
}

export const recommendationsIndexQuery = (
  params: RecommendationsIndexParams,
) => ({
  url,
  method: "GET",
  params,
});

export type RecommendationsCreateParams = {
  content: string;
  actionType: RecommendationType;
};

export const recommendationsCreateQuery = (
  params: RecommendationsCreateParams,
) => ({
  url,
  method: "POST",
  body: params,
});

export type RecommendationsUpdateParams = {
  id: RecommendationSerializer["attributes"]["id"];
  completed?: boolean;
  note?: string;
  removed?: boolean;
  saved?: boolean;
};

export const recommendationsUpdateQuery = ({
  id,
  ...params
}: RecommendationsUpdateParams) => ({
  url: `${url}/${id}`,
  method: "PATCH",
  body: params,
});
